import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { BoatOwnerDAO } from '../../../../core/services/dao/boatOwnerDAO';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { environment } from '../../../../environments/environment';

@Injectable()
export class BoatOwnerResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private boatOwnerDao: BoatOwnerDAO,
    private userDAO: UserDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const sessionResolve = this.authService.checkSession();
    const boatOwnerResolve = this.boatOwnerDao.loadBoatOwnerUsersGrid();
    return combineLatest([sessionResolve, boatOwnerResolve]).pipe(
      map(([sessionResolve, boatOwnerResolve]) => ({
        sessionResolve,
        boatOwnerResolve,
      })),
      take(1),
    );
  }
}
